import { render, staticRenderFns } from "./TeachingResources.vue?vue&type=template&id=33bec102&scoped=true&"
import script from "./TeachingResources.vue?vue&type=script&lang=ts&"
export * from "./TeachingResources.vue?vue&type=script&lang=ts&"
import style0 from "./TeachingResources.vue?vue&type=style&index=0&id=33bec102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bec102",
  null
  
)

export default component.exports